import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { orderUploadStyles } from "@insite/content-library/Components/OrderUpload";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

orderUploadStyles.downloadTemplateButton = mergeToNew(orderUploadStyles.downloadTemplateButton, {
    variant: "primary",
    color: "common.accent",
    css: css`
        color: white;
        margin-bottom: 15px;
    `,
});

orderUploadStyles.uploadFileButton = mergeToNew(orderUploadStyles.uploadFileButton, {
    variant: "primary",
    color: "common.accent",
    css: css`
        color: white;
        float: right;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        margin-bottom: 10px;
                        width: 100%;
                    `,
                    css`
                        margin-left: 15px;
                        width: initial;
                    `,
                ],
                "min",
            )}
    `,
});

orderUploadStyles.fileUploader = mergeToNew(orderUploadStyles.fileUploader, {
    buttonProps: {
        variant: "primary",
        color: "common.accent",
        css: css`
            color: white;
        `,
    },
});
